export const isLimitlessWallet = (isLimitless: string | undefined) => {
    return isLimitless === "true";
};
